import {
  CmsApiBlock,
  CmsApiBlockType,
} from 'modules/cms/api/types/CmsApiBlock';
import { MappedContentBlock } from 'modules/cms/mappers/MappedContentBlock';

const blocksWithDividers: CmsApiBlockType[] = [
  'RANDOM_GRAD_PROGRAMS',
  'RECOMMENDED_ACTIONS',
  'RECOMMENDED_JOBS',
  'THREE_SECTION_SLIDER',
  'FOUR_ARTICLES_HIGHLIGHT',
  'THREE_STEP_CTA',
];

export function mustHaveDivider<TBlock extends CmsApiBlock>(
  block: MappedContentBlock<TBlock>
) {
  return blocksWithDividers.includes(block.type) && !block.mustNotHaveDivider;
}
